import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["usageTracker", "componentName", "stopPropagation", "onClick", "screen"];
import { useUserCanEditBilling } from '../../hooks/useUserCanEditBilling';
import { ComponentViewTracker } from './ComponentViewTracker';
import { trackClick } from './trackingFunctions';
import { jsx as _jsx } from "react/jsx-runtime";
export function withClickTracking(WrappedComponent) {
  return function ClickTrackedComponent(_ref) {
    let {
        usageTracker,
        componentName,
        stopPropagation = false,
        onClick,
        screen
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    const userCanEditBilling = useUserCanEditBilling();
    const handleClick = event => {
      if (stopPropagation) {
        event.stopPropagation();
      }
      trackClick(usageTracker, {
        component: componentName,
        screen,
        isBillingAdmin: userCanEditBilling
      });
      if (onClick) {
        onClick(event);
      }
    };
    return /*#__PURE__*/_jsx(ComponentViewTracker, {
      usageTracker: usageTracker,
      componentName: componentName,
      screen: screen,
      children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
        onClick: handleClick
      }, rest))
    });
  };
}